/**
 * @voltxampere/ui — AddAnnotationCommand (Sprint 14)
 *
 * Append a single Annotation record. Sprint 14 only ships the
 * `text` kind via `AnnotationTool` (T shortcut); the schema also
 * declares `box`, `arrow`, and `image` for Sprint 15+ shape /
 * media annotations — this command stays kind-agnostic so the
 * later tools can reuse it.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export class AddAnnotationCommand {
    annotation;
    constructor(annotation) {
        this.annotation = annotation;
    }
    do(circuit) {
        return {
            ...circuit,
            annotations: [...circuit.annotations, this.annotation],
        };
    }
    undo(circuit) {
        return {
            ...circuit,
            annotations: circuit.annotations.filter((a) => a.id !== this.annotation.id),
        };
    }
    describe() {
        return "Annotation eklendi";
    }
}
//# sourceMappingURL=add-annotation.js.map